// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aa683165","453":"018e7892","455":"f32a07d7","977":"a8f1ae85"}[chunkId] + ".chunk.js";
};